/* @flow */
import invariant from 'invariant';
import apiRequest from 'lib/apiRequest';
import EventTracking from 'lib/EventTracking';

function remindApiAuthorizer (Runtime, socketId: string, callback: Function) {
  // to match https://github.com/pusher/pusher-js/blob/master/src/runtimes/isomorphic/auth/xhr_auth.ts
  apiRequest('/pusher/auth', 'POST', {
    socket_id: socketId,
    channel_name: this.channel.name,
  })
  .then(data => callback(false, data))
  .catch(err => {
    console.error('DEBUG remindApiAuthorizer failure', err);
    callback(true, err.message);
  });
}

let singleton = null;

function ensureSingleton(key: string) {
  if (singleton) {
    return;
  }

  // Postpone module load until there's a connection to be opened so that this
  // PusherConnection module can load in Node.
  const Pusher = require('pusher-js');

  const supportedAuthorizers = Pusher.Runtime.getAuthorizers();
  Pusher.Runtime.getAuthorizers = function () {
    supportedAuthorizers.remindApi = remindApiAuthorizer;
    return supportedAuthorizers;
  };

  singleton = new Pusher(key, {
    authTransport: 'remindApi',
    encrypted: true,
  });

  // https://pusher.com/docs/client_api_guide/client_connect#available-states
  singleton.connection.bind('state_change', function({ previous, current }) {
    EventTracking.track(`pusher.state_change.${previous}.to.${current}`);
  });

  window.addEventListener('beforeunload', () => {
    closeConnection();
  });
}

/**
 * @param  {[String]} key required to open a connection
 * @return {[Pusher]} connection singleton
 */
export function openConnection(key: string) {
  invariant(key, 'Missing Pusher key.');

  ensureSingleton(key);
  invariant(singleton, 'Connection not available to open');

  singleton.connect(); // idempotent

  return singleton;
}

export function closeConnection() {
  if (singleton) {
    singleton.disconnect();
    // leave the singleton object to reconnect if needed
  }
}

export function resetConnection() {
  invariant(singleton, 'Connection not available to reset');
  singleton.disconnect();
  singleton.connect();
}



// WEBPACK FOOTER //
// ./src/pusher/PusherConnection.js